import { createFileRoute } from '@tanstack/react-router'
import { MarkdownText } from 'ui-kit'
import { Container } from '@mui/material'
import Request from '@src/services/api/Request'
import { routePageHead } from '@src/utils/routeHead'
import type { ComplaintsAttributes } from '@src/types/strapi'

const legalPageSx = {
  pb: 4,
  '& h1, & h2, & h3, & h4': { mt: 1.5, mb: 0, mx: 0 },
  '& a': { color: 'primary.light', textDecoration: 'underline' },
  '& li': { listStyle: 'decimal', ml: 3, my: 0, mr: 0 },
} as const

export const Route = createFileRoute('/complaints')({
  loader: async () => {
    const complaints = (await Request.complaints()) || {}
    return { complaints: complaints?.attributes ?? null }
  },
  staleTime: 60_000,
  head: ({ loaderData }) =>
    routePageHead(loaderData?.complaints?.seo?.pageTitle),
  component: ComplaintsPage,
})

function ComplaintsPage() {
  const { complaints } = Route.useLoaderData() as {
    complaints: ComplaintsAttributes | null
  }

  return (
    <Container maxWidth="lg" sx={legalPageSx}>
      <MarkdownText allowHtml>{complaints?.fcaComplaints ?? ''}</MarkdownText>
    </Container>
  )
}
